import { call, put, select } from 'redux-saga/effects';
import { setDomainSettings } from '../../../../state/analytic/analyticAdminSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchDomainSettingsSaga() {
    const { domain } = yield select(selectUserCredentials);
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `admin/domains/${encodeURIComponent(domain)}/settings`
        );
        yield put(setDomainSettings(data));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch domain settings', err?.response?.status, err?.message);
    }
}